import { type QueryKeyRoot } from '../queryKeyRoots';

export const LICENSE_QUERY_KEYS = {
  assetLicense: (assetId: string) =>
    ['assetLicense', assetId] as const satisfies readonly [
      QueryKeyRoot,
      ...unknown[]
    ],
} as const;
